export default __webpack_public_path__ + "static/media/sec-3-top1.9b77a072.png";